import { NavLink, useNavigate } from 'react-router-dom';
import { useAdminAuth } from './AdminAuthContext';
import s from './AdminLayout.module.css';

const NAV = [
  { to: '/admin',          icon: '▦',  label: 'Dashboard', end: true },
  { to: '/admin/orders',   icon: '📦', label: 'Orders'     },
  { to: '/admin/products', icon: '🛍', label: 'Products'   },
  { to: '/admin/pending',  icon: '⏳', label: 'Pending'    },
  { to: '/admin/sellers',  icon: '🏪', label: 'Sellers'    },
];

export default function AdminLayout({ children }) {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/admin/auth'); };

  return (
    <div className={s.shell}>
      <aside className={s.sidebar}>
        <div className={s.logo}>
          <span className={s.logoV}>V</span>
          <span className={s.logoLabel}>Admin</span>
        </div>

        <nav className={s.nav}>
          {NAV.map(n => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) => `${s.navItem} ${isActive ? s.navActive : ''}`}
            >
              <span className={s.navIcon}>{n.icon}</span>
              <span>{n.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className={s.bottom}>
          <div className={s.adminCard}>
            <div className={s.avatar}>{admin?.name?.charAt(0) || 'A'}</div>
            <div>
              <p className={s.adminName}>{admin?.name || 'Admin'}</p>
              <p className={s.adminRole}>Super Admin</p>
            </div>
          </div>
          <button className={s.logoutBtn} onClick={handleLogout}>Sign out</button>
        </div>
      </aside>

      <main className={s.main}>{children}</main>
    </div>
  );
}
